<ng-template #countryTemplate let-option>
    <span class="flex items-center gap-4">
        <img
            src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
            [class]="'flag flag-' + option.data.code.toLowerCase()"
            style="width: 18px" />
        <span class="font-semibold">{{ option.label }}</span>
    </span>
</ng-template>

<valben-searchable-select
    class="w-52"
    placeholder="Odaberite državu"
    [options]="countryOptions()"
    [optionTemplate]="countryTemplate"
    [value]="selectedCountryCode()"
    (valueChange)="selectCountry($event)" />
